import { render, staticRenderFns } from "./DialogInfoTable.vue?vue&type=template&id=30d7866c&scoped=true"
import script from "./DialogInfoTable.vue?vue&type=script&lang=js"
export * from "./DialogInfoTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d7866c",
  null
  
)

export default component.exports